import React, {Component, Fragment} from 'react';
import * as mobx from 'mobx';
import {inject, observer, Provider} from "mobx-react";
import {DuplicateListingsSummary, MissingListingDetails, ListingFoundVsExpected} from '../../listings/components/';
import SocialTask from '../../social/components/SocialTask';
import MediaTask from '../../media/components/MediaTask';
import {Spinner} from "../../../components";
import RespondToReview from './entities/RespondToReview'
import GoToActionButton from './entities/GoToActionButton'
import {getPathAndQuery} from "../../../util/UrlFragmentSearch";
import {analyticsTaskData} from '../analyticsHelper';
import {recordEvent} from '../../app/plugins/metricPlugin';
import {ScheduledPostCard} from '../../../modules/social/publishing/components/ScheduledPostCard'
import ScheduledPostStore from '../../../modules/social/publishing/ScheduledPostStore'


const Todo = ({entity}) => <span>(no component yet)<pre>{JSON.stringify(mobx.toJS(entity), null, 2)}</pre></span>

const maybeTargetBlank = { target: "_blank" }
@inject("taskStore")
@observer
class WorkflowTaskEntity extends Component {

  scheduledPostStore = new ScheduledPostStore();

  entityComponentsByTaskType = {
    RespondToReview: (props) =>  (<RespondToReview {...props}/>),

    AddListing: ({ entity: { location }, task: {entityId} }) => {
      const provider = entityId.split('/')[1];
      return <Fragment>
        <MissingListingDetails location={location} provider={provider}/>
        <GoToActionButton
          {...maybeTargetBlank}
          href={`#/listings?reportType=MissingListings&range=AllTime&groupId=${location.locationId}&providers=${provider}`}
          onMouseDown={() => recordEvent("Task Entity Viewed", analyticsTaskData(this.props.taskStore.original))}
        >
          Missing Listings Report
        </GoToActionButton>
      </Fragment>
    },

    OptimizeListing: ({ entity: { listing }}) => <Fragment>
      <ListingFoundVsExpected listing={listing} />
      <GoToActionButton
        {...maybeTargetBlank}
        href={listing.listingURL}
        onMouseDown={() => recordEvent("Task Entity Viewed", analyticsTaskData(this.props.taskStore.original))}
      >View Listing</GoToActionButton>
    </Fragment>,

    UpdateListingDetails: ({ entity: { listing }}) => <Fragment>
      <ListingFoundVsExpected listing={listing} />
      <GoToActionButton
        {...maybeTargetBlank}
        href={listing.listingURL}
        onMouseDown={() => recordEvent("Task Entity Viewed", analyticsTaskData(this.props.taskStore.original))}
      >View Listing</GoToActionButton>
    </Fragment>,

    DeleteDuplicateListing:({entity: { duplicateListings, bestListing }}) =>
      <Fragment>
        <DuplicateListingsSummary bestListing={bestListing} duplicateListings={duplicateListings}/>
      </Fragment>,

    //TODO - entity should prob be have a child property of type as others do
    RespondToPost: ({ entity: { post } }) => <Fragment>
      <SocialTask post={post}  onChangeStatus={() => this.props.taskStore.reloadTask()} />
      <GoToActionButton
        {...maybeTargetBlank}
        href={`#/social/activity/${post.postId}`}
        onMouseDown={() => recordEvent("Task Entity Viewed", analyticsTaskData(this.props.taskStore.original))}
      >View Post</GoToActionButton>

    </Fragment>,

    FlagPhoto: ({ entity: { media }}) => <Fragment>
      <MediaTask media={media} />
      <GoToActionButton
        {...maybeTargetBlank}
        href={media.listingUrl}
        onMouseDown={() => recordEvent("Task Entity Viewed", analyticsTaskData(this.props.taskStore.original))} >
        Flag Photo
      </GoToActionButton>
    </Fragment>,

    RespondToPhoto: ({ entity: { media }}) => <Fragment>
      <MediaTask media={media} />
      <GoToActionButton
        {...maybeTargetBlank}
        href={media.listingUrl}
        onMouseDown={() => recordEvent("Task Entity Viewed", analyticsTaskData(this.props.taskStore.original))} >
        Respond To Photo
      </GoToActionButton>
    </Fragment>,

    SharePhoto: ({ entity: { media }}) => <Fragment>
      <MediaTask media={media} />
      <GoToActionButton
        {...maybeTargetBlank}
        href={media.listingUrl}
        onMouseDown={() => recordEvent("Task Entity Viewed", analyticsTaskData(this.props.taskStore.original))} >
        Share Photo
      </GoToActionButton>
    </Fragment>,

    PublishPost: ({ entity: { postToBePublished } }) => <Fragment>
      <Provider scheduledPostStore={this.scheduledPostStore}>
        <ScheduledPostCard post={postToBePublished} hideControls />
        <GoToActionButton
          {...maybeTargetBlank}
          href={`#/social/publishing/${postToBePublished._id.$oid ? postToBePublished._id.$oid: postToBePublished._id }`}
          onMouseDown={() => recordEvent("Task Entity Viewed", analyticsTaskData(this.props.taskStore.original))} >
          View Post
        </GoToActionButton>
      </Provider>
    </Fragment>

  }

  render() {
    const {taskStore} = this.props;

    let content;
    if (taskStore.isLoadingTaskData) {
      content = <Spinner center timeout={100} size={'md'}/>
    } else if (!!taskStore.taskData && taskStore.taskData.empty) {
      content = <div className="alert alert-warning">Task entity not found. It may no longer be valid or has been deleted.</div>
    } else if (!!taskStore.taskData) {
      const SubType = this.entityComponentsByTaskType[taskStore.original.taskType] || Todo;
      content = <SubType entity={taskStore.taskData} task={taskStore.editing} />
    }

    return (
      <div>
        {content}
      </div>
    );
  }
}

export default WorkflowTaskEntity;
